/**
 * Converte fileType (snake_case usado em props/API) para a chave de form no state (camelCase).
 * @param {string} fileType
 * @returns {string}
 */
export function fileTypeToFormKey(fileType) {
	switch (fileType) {
		case "social_contract":
			return "socialContract";
		case "second_address":
			return "secondAddress";
		case "address_partners":
			return "addressPartners";
		default:
			return fileType;
	}
}
